module.exports = __webpack_public_path__ + "static/img/logo-blue-wide-small.79d545c6.png";